import { RESET, SET_SELECTED_PROGRESS } from "./progressFilter.actionTypes";
import { PROGRESS_VALUES } from "./progressFilter.constants";
import * as selectors from "./progressFilter.selectors";

export const reset = () => (dispatch) => {
  dispatch({
    type: RESET,
  });
};

export const setSelectedProgress = (data) => (dispatch) => {
  dispatch({
    type: SET_SELECTED_PROGRESS,
    payload: data,
  });
};

// Toggle a single progress value. `""` is the "All" master: when all three are selected it clears
// the group (nothing selected -> empty board); otherwise it selects all three.
export const setProgressFilter = (value) => (dispatch, getState) => {
  const selectedProgress = selectors.getSelectedProgress(getState());

  if (value === "") {
    if (selectedProgress.length === PROGRESS_VALUES.length) {
      return dispatch(setSelectedProgress([]));
    }

    return dispatch(setSelectedProgress([...PROGRESS_VALUES]));
  }

  if (selectedProgress.includes(value)) {
    return dispatch(setSelectedProgress(selectedProgress.filter((v) => v !== value)));
  }

  return dispatch(setSelectedProgress([...selectedProgress, value]));
};

export const selectAllProgress = () => (dispatch) => {
  dispatch(setSelectedProgress([...PROGRESS_VALUES]));
};
